import { z } from 'zod/v4';
import { AmforiSyncHistoryResourceSchema } from '../schemas/sync-history-resource.js';

/**
 * Querystring for `GET /integrations/amfori/history`. `page` is 0-indexed;
 * `pageSize` defaults to 25 and is capped at 100. Sort is fixed to
 * `started_at DESC` (newest first), so it is not a query param.
 */
export const ListAmforiSyncHistoryQuerySchema = z.object({
  page: z.coerce.number().int().min(0).default(0),
  pageSize: z.coerce.number().int().min(1).max(100).default(25),
});

export type ListAmforiSyncHistoryQuery = z.infer<
  typeof ListAmforiSyncHistoryQuerySchema
>;

/**
 * `GET /integrations/amfori/history` — brand-scoped, paginated list of the
 * caller's past amfori sync runs, newest first. Always 200 with an array
 * (empty when the brand has never synced) — never 404. Sibling to the
 * single-run PDF route (`GetAmforiSyncReportContract`).
 */
export const ListAmforiSyncHistoryContract = {
  method: 'GET',
  path: '/integrations/amfori/history',
  query: ListAmforiSyncHistoryQuerySchema,
  response: z.array(AmforiSyncHistoryResourceSchema),
} as const;
